import * as React from "react";
import { useRef } from "react";
import useElementDimensions from "hooks/useElementDimensions";
const ElementDimensions = ({ children, className = void 0, resizeDelay = void 0 }) => {
  const element = useRef(null);
  const dimensions = useElementDimensions(element, resizeDelay);
  return /* @__PURE__ */ React.createElement("div", { ref: element, className }, children(dimensions));
};
export default ElementDimensions;
